import React, { useState } from 'react'
import logo from '../images/logo.svg'
import work from '../images/illustration-working.svg'
import Shorter from './Shorter';
import Sidebar from './Sidebar';

function Header() {

  let [nav,setNav] = useState(false);


  return (
    <div className='h-[50rem] relative w-full sm:h-[42rem] bg-white'>
      <img src={logo} alt='logo' className='absolute sm:top-[2rem] sm:left-[10rem] left-[2rem] top-[3rem]' />
      <ul className='flex text-[0px] sm:text-[16px]   absolute sm:left-[20rem] sm:top-[2rem] flex-row gap-8 text-[rgba(0,0,0,0.5)] font-medium'>
        <li className='hover:text-black hover:cursor-pointer'>Features</li>
        <li className='hover:text-black hover:cursor-pointer'>Pricing</li>
        <li className='hover:text-black hover:cursor-pointer'>Resources</li>
      </ul>
      {
        nav === true ? <Sidebar/> : ''
      }
      

      <ul className='flex absolute  sm:right-[10rem] sm:top-[2rem]  flex-row gap-10 '>
        <li className='mt-2 text-[0px] hover:cursor-pointer hover:text-black sm:text-[16px] font-medium text-[rgba(0,0,0,0.4)]'>Login</li>
        <button className='sm:bg-[#32CDCF] hover:bg-[rgb(84,223,225)] bg-white text-[0px] sm:text-[16px] font-medium text-white rounded-full pr-6 pl-6 pb-2 pt-2'>Sign Up</button>
      </ul>

      <div onClick={(e) => setNav(!nav)} className='text-2xl absolute sm:hidden right-[2rem] top-[3rem] border border-[rgba(0,0,0,0.5)] text-center w-10'>&#65049;</div>
      <img src={work} alt='working-img' className='absolute sm:left-[47rem] sm:h-[26rem] sm:w-[38rem]  w-[20rem] top-[7rem] left-[2rem]' />
      <h1 className='text-5xl sm:leading-none sm:left-[10rem] sm:top-[12rem] sm:text-7xl text-[#2a272e] left-[2rem] sm:text-left absolute top-[22rem] text-center font-semibold'>More than just <br /> shorter links</h1>
      <p className='text-[rgb(140,140,149)] sm:text-[0px] text-lg text-center absolute left-[3rem] top-[29rem]'>Build your brand's recognition and <br /> get detailed insights on how your <br /> links are performing.</p>
      <p className='text-[rgb(140,140,149)] text-[0px] sm:top-[22rem] sm:text-2xl sm:left-[10rem]   absolute left-[3rem] top-[29rem]'>Build your brand's recognition and get detailed <br /> insights on how your  links are performing.</p>

      <button className='bg-[#2bd1d1] sm:top-[28rem] hover:cursor-pointer hover:bg-[rgb(102,229,229)] sm:left-[10rem] text-xl rounded-full text-white font-semibold absolute top-[36rem] left-[6rem] pl-10 pr-10 pt-4 pb-4'>Get Started</button>
      <Shorter />
    </div>
  )
}

export default Header;